import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";

export type DropdownPredicate<T> = (item: T) => boolean;

export interface DropdownOption<T, V extends string = string> {
    id?: string; // use this in your options if you have duplicate keys
    key: string;
    predicate?: DropdownPredicate<T>;
    value?: V; // use this when you want to use predicateDropdownMenu's initialValue binding
    extraData?: any;
}

/** @deprecated */
@Component({
    selector: "predicate-dropdown-menu",
    template: `
        <div class="default-cursor"
             *ngIf="disabled">
            <span class="dropdown-label">{{ label | localize }}:</span>
            <span class="dropdown-value">{{ selectedOption?.key | localize }}</span>
        </div>
        <pr-dropdown *ngIf="!disabled"
                     [align]="align"
                     (popupShown)="dropdownVisible = true"
                     (popupHidden)="dropdownVisible = false">
            <div pr-dropdown-trigger
                 class="link-dropdown"
                 test-class="pr-dropdown-trigger">
                <span class="dropdown-label">{{ label | localize }}:</span>
                <span class="dropdown-value">{{ selectedOption?.key | localize }}</span>
                <i class="far dropdown"
                   [ngClass]="{'fa-chevron-up': dropdownVisible, 'fa-chevron-down': !dropdownVisible}"></i>
            </div>
            <ul pr-dropdown-body test-class="pr-dropdown-body">
                <li *ngFor="let option of options; trackBy: trackByFn"
                    [attr.test-class]="'dropdown-' + option.key"
                    (click)="selectOption(option)"
                    [ngClass]="{'active': isActiveOption(option)}">
                    {{ option.key | localize }}
                    <i class="far fa-check"></i>
                </li>
            </ul>
        </pr-dropdown>
    `,
})
export class PredicateDropdownMenuComponent<T, V extends string> implements OnChanges {
    @Input() options: DropdownOption<T, V>[];
    @Input() label: string;
    @Input() initialValue: V;
    @Input() align: string;
    @Input() disabled: boolean;
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onSelect = new EventEmitter<DropdownOption<T, V>>();

    selectedOption: DropdownOption<T, V>;
    dropdownVisible: boolean = false;

    ngOnChanges() {
        if (!this.options || !this.options.length) {
            return;
        }
        this.selectedOption = this.options[0];
        if (this.initialValue) {
            this.selectedOption = this.options.find(opt => opt.id === this.initialValue || opt.value === this.initialValue);
            if (this.selectedOption) {
                this.onSelect.emit(this.selectedOption);
            }
        }
    }

    selectOption(selectedOption: DropdownOption<T, V>) {
        this.selectedOption = selectedOption;
        this.onSelect.emit(selectedOption);
    }

    trackByFn(index, item) {
        return item.key + item.id;
    }

    // When the dropdown options have duplicate keys, we should
    // use the DropdownOption.id field to find the active option
    isActiveOption(option: DropdownOption<T, V>): boolean {
        if (option.id === undefined) {
            return option.key === this.selectedOption?.key;
        } else {
            return option.id === this.selectedOption?.id;
        }
    }
}
